import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {RecentAccountPaymentHistoryReportDto} from '../../dtos/recentAccountPaymentHistoryReportDto';
import {RecentAccountActivityReportDto} from '../../dtos/recentAccountActivityReport.dto';

@Injectable({
    providedIn: 'root'
})
export class ReportAdminService {

    constructor(private httpClient: HttpClient) {
    }

    // This is deliberately like this because the response of the recent account activity is very large in size.
    public getRecentAccountActivity = (): Observable<RecentAccountActivityReportDto> => {
        return this.httpClient.get<any>(environment.apiUrl + 'api/reports/v1/recentAccountActivityReport')
            .pipe(map((report: any) => {
                return new RecentAccountActivityReportDto().deserialize(report);
        }));
    }

    public getRecentAccountPayments(): Observable<RecentAccountPaymentHistoryReportDto> {
        return this.httpClient.get<any>(environment.apiUrl + 'api/reports/v1/recentAccountPaymentHistory')
            .pipe(map((reportsData: any) => {
                return new RecentAccountPaymentHistoryReportDto().deserialize(reportsData);
            }));
    }
}
